import { render } from "./NewsLetter.vue?vue&type=template&id=4975e2ee&scoped=true"
import script from "./NewsLetter.vue?vue&type=script&lang=js"
export * from "./NewsLetter.vue?vue&type=script&lang=js"

import "./NewsLetter.vue?vue&type=style&index=0&id=4975e2ee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4975e2ee"]])

export default __exports__